export default "__VITE_ASSET__lmXQPc$8__"